import React, { forwardRef, ForwardedRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

type TLinkProps = Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] };

interface ILinkProps extends TLinkProps {}

function Link({ href, ...props }: ILinkProps, ref: ForwardedRef<HTMLAnchorElement>) {
	return (
		<RouterLink ref={ref} to={href} {...props} />
	);
}

export default forwardRef(Link);
